import { render, staticRenderFns } from "./DepartmentResultsChart.vue?vue&type=template&id=341805d0&"
import script from "./DepartmentResultsChart.vue?vue&type=script&lang=js&"
export * from "./DepartmentResultsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports